<template>
  <div class="vue timparty-user-profile-form user-profile-form">
    <LoaderOverlay v-if="loading"/>

    <div class="bg-dark py-4 user-profile-form-heading">
      <div class="container">
        <div class="row">

          <div class="col-sm-9 d-md-flex d-none align-items-center" v-if="user">
            <img :src="user.cluster_image" :alt="user.cluster_name" class="cluster-image mr-4">
            <h5 class="d-inline-block text-white">
              Sei un cliente <strong class="text-accent" :style=" user.cluster_color ? 'color: ' + user.cluster_color + '!important;' : '' ">{{ user.cluster_name }}</strong><br>
            </h5>
            <user-cluster :profile="true"></user-cluster>

          </div>
          <div class="col-sm-9 d-flex d-md-none align-items-center" v-if="user">
          </div>

<!--          <div class="col-10 offset-1 d-md-none d-flex align-items-center separe-blue mt-1 mb-4"></div>-->
          <div class="col-sm-3 d-flex row">
<!--            <div class="col-sm-12 d-flex align-items-center justify-content-start  justify-content-md-end"-->
<!--                 v-if="coupons.length > 0">-->
<!--              <a @click='aaEvent("click", { form: { click: "PIN – Negozi TIM" } })' href="/pin-attivi"-->
<!--                 class="text-white ">{{ __('PIN – NEGOZI TIM') }}&nbsp;&rsaquo;</a>-->
<!--            </div>-->
            <div class="col-sm-12 d-flex align-items-center justify-content-start  justify-content-md-end">
              <a @click='aaEvent("click", { form: { click: "Vantaggi richiesti" } })' href="/vantaggi-richiesti"
                 class="text-white ">{{ __('I VANTAGGI RICHIESTI') }}&nbsp;&rsaquo;</a>
            </div>
            <div class="col-sm-12 d-flex align-items-center justify-content-start  justify-content-md-end">
              <a @click='aaEvent("click", { form: { click: "Le tue vincite" } })' href="/le-tue-vincite"
                 class="text-white ">{{ __('LE TUE VINCITE') }}&nbsp;&rsaquo;</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">

      <div class="row">
        <div class="col-sm-4">
          <h1 class="h3 font-weight-bold my-4 text-dark">{{ txt.form_title }}</h1>
        </div>
        <div class="col-sm-4 pt-4" v-if="user">
          <div class="text-primary-light mt-2 mb-3 d-none d-sm-block">{{ txt.phone_label }}</div>
        </div>
      </div>


      <div class="form-timparty">

        <!-- MAIN FORM - BEGIN -->
        <div class="row">
          <div class="col-sm-4" v-if="user">
            <div class="form-group">
              <label for="line_number">{{ __('Linea') }}</label>
              <input id="line_number" disabled type="text" class="form-control" v-model="user.loyalty_line">
            </div>
          </div>
          <!--
          <div class="col-sm-4">
            <div :class="'form-group ' + (validation_errors.email ? 'has-error' : '')">
              <label for="email">{{ __('Email') }}*</label>
              <input id="email" type="text" class="form-control" v-model="userdata.email">
            </div>
          </div>
          -->
          <div class="col-sm-4">
            <div class="text-primary-light mt-2 mb-3 d-sm-none">{{ txt.phone_label }}</div>
            <div :class="'form-group '">
              <label for="phone">{{ __('Telefono di contatto') }}</label>
              <input id="phone" type="text"
                     :class="'form-control '  + (validation_errors.phone ? 'border-danger' : '')"
                     v-on:change="enableOrDisableButton"
                     v-on:keyup="enableOrDisableButton"
                     v-model="userdata.phone"
              >
            </div>
          </div>
        </div>


        <!-- PRIVACY CONSENT - BEGIN -->

        <!--
        <div :class="'form-group mb-0 ' + (validation_errors.flg_privacy_mail ? 'has-error' : '')">
            <div class="custom-control custom-checkbox p-4">
              <input type="checkbox" class="custom-control-input" id="flg_privacy_mail" v-model="userdata.flg_privacy_mail">
              <label class="custom-control-label" for="flg_privacy_mail">{{ __('Iscriviti alla Newsletter per rimanere sempre aggiornato sulle nuove iniziative') }}</label>
            </div>
        </div>
        -->

        <div :class="'form-group mb-0 ' + (validation_errors.privacy_acceptance ? 'has-error' : '')">
          <div class="custom-control custom-checkbox align-middle">
            <input type="checkbox" class="custom-control-input" id="privacy-acceptance" v-model="privacy_acceptance">
            <label class="custom-control-label" :class="{ underlined: validation_errors.privacy_acceptance }"
                   for="privacy-acceptance">
              <span class="mt-1">{{ txt.privacy_label }}</span>
              <span>
                      <a v-if="user" :href="user.privacy_policy_url" target="_blank" class="icon-privacy-info ml-1"><img
                        :src="modulePath('js/src/assets/images/icon-black-info-square.png')"></a>
                      <a v-else-if="!hideInfo" href="#" class="icon-privacy-info ml-1"
                         @click.prevent="modal.show = true"><img
                        :src="modulePath('js/src/assets/images/icon-black-info-square.png')"></a>
                    </span>
            </label>
          </div>
        </div>
        <!-- PRIVACY CONSENT - END -->


        <!-- ID ATTACHMENT / DEPRECATED - BEGIN -->
        <!--
        <div v-if="idRequired" :class="'form-group ' + (validation_errors.id_attachment ? 'has-error' : '')">
            <div class="p-4 mt-4">

              <div v-if="idFilename">
                <button @click.prevent="idFilename = null">X</button>{{ idFilename }}
              </div>
              <div v-else>
                <input id="id-attachment-input" class="d-none" type="file" @change="handleFileChange">
                <a href="#" @click.prevent="triggerFileInput">{{ __('Carica il documento d’identità (.pdf, .jpg, .png, max 5Mb)') }}</a>
              </div>


            </div>
        </div>
        -->
        <!-- ID ATTACHMENT / DEPRECATED - END -->


        <div class="form-actions my-4 text-center">
          <button class="btn btn-primary btn-lg" :disabled="button_disabled" @click.prevent="submitForm">{{
              __('Salva')
            }}
          </button>
        </div>

        <div class="my-3 text-center" :class="alert.class_name" v-html="alert.message"></div>

      </div>

    </div>


    <!-- PRIVACY POLICY / START -->
    <basic-modal :modal-id="modal_id" modal-class="modal-sm" class="modal-acceptance" :show="modal.show"
                 v-on:modalClose="modal.show = false">

      <div class="modal-body p-5">
        <ContentPrivacyPolicy/>
      </div>

    </basic-modal>
    <!-- PRIVACY POLICY / END -->


    <!-- MODAL ERROR / BEGIN -->
    <ErrorModal :error="error" v-on:modalClose="error = null"/>
    <!-- MODAL ERROR / END -->
  </div>
</template>


<script>

/* eslint-disable */

import UserCluster          from "@/components/UserCluster";
import TimPartyMixin        from '../mixins/TimPartyMixin';
import LoaderOverlay        from './LoaderOverlay.vue'
import ErrorModal           from './ErrorModal.vue'
import BasicModal           from './BasicModal.vue'
import ContentPrivacyPolicy from './ContentPrivacyPolicy.vue'

export default {
  name: 'UserProfileForm',
  mixins: [TimPartyMixin],
  components: {
    UserCluster,
    LoaderOverlay,
    ErrorModal,
    BasicModal,
    ContentPrivacyPolicy
  },
  props: {
    apiUrl: {
      type: String
    },
    texts: {
      type: Object,
      default: {}
    }

  },
  data: function () {
    return {
      userdata: {},

      txt: {
        privacy_label: 'Ho preso visione dell\'Informativa Privacy',
        phone_label: 'Ulteriore recapito telefonico',
        form_title: 'I tuoi dati',
        form_validation_error_title: 'Errore nella compilazione del modulo.',
        form_validation_error_summary: ' Si prega di verificare i campi indicati',
        message_save_success: 'Abbiamo salvato correttamente il tuo telefono di contatto',
        message_save_error: 'Errore nel salvataggio dei dati'
      },

      button_disabled: false,

      privacy_acceptance: false,


      validation_errors: {},

      modal: {
        id: 'modal-profile-form',
        show: false,
        class_name: 'modal-lg'

      },

      alert: {
        class_name: '',
        message: ''
      },
      loading: false,
      coupons: []
    };
  },
  mounted: function () {
    this.setApiUrl(this.apiUrl);

    if (this.user) {
      this.userdata = this.user;
    }

    this.txt = {...this.txt, ...this.texts};
    this.getRetrievedCoupons();

  },

  methods: {
    enableOrDisableButton: function () {
      if (this.userdata.phone) {
        this.button_disabled = false;
      }
      else {
        this.button_disabled = true;
      }
    },
    validateForm: function () {

      var result = true;


      // EMAIL
      /*
      if( !this.checkEmail( this.userdata.email ) ){
        result = false;
        this.validation_errors['email'] = true;
      }
      else{
        this.validation_errors['email'] = false;
      }
      */


      // PHONE

      if (!this.userdata.phone || (this.userdata.phone == '') || (isNaN(this.userdata.phone))) {
        result                          = false;
        this.validation_errors['phone'] = true;
      }
      else {
        this.validation_errors['phone'] = false;
      }


      // PRIVACY ACCEPTANCE

      if (!this.privacy_acceptance) {
        result                                       = false;
        this.validation_errors['privacy_acceptance'] = true;
      }
      else {
        this.validation_errors['privacy_acceptance'] = false;
      }


      return result;
    },

    submitForm: function () {
      if (!this.validateForm()) {

        this.modal.show = false;
        this.showError(this.txt.form_validation_error_title, this.txt.form_validation_error_summary);
        return;
      }
      this.setApiUrl(this.user.endpoints.user);

      this.aaEvent('click', {
        form: {
          click: "Salva"
        }
      });

      var self = this;

      var payload = {
        action: 'updateProfile',
        access_token: this.access_token,
        data: {

          // email: this.userdata.email,
          phone: this.userdata.phone
          //newsletter: this.userdata.flg_privacy_mail,
        }

      };

      this.loading = true;
      this.callApi(payload, function (response) {

        self.loading = false;

        if (response.success) {

          self.alert.class_name = 'text-success';
          self.alert.message    = self.txt.message_save_success;
        } else {
          self.alert.class_name = 'text-danger';
          self.alert.message    = self.txt.message_save_error;
        }
      });
    },
    getRetrievedCoupons: function () {
      this.setApiUrl(this.user.endpoints.catalog);
      var self = this;

      var payload = {
        action: 'getRetrievedShopCoupons',
        access_token: this.accessToken
      };

      self.loading = true;
      this.callApi(payload, function (response) {
        var coupons = [];
        var row     = {};
        for (var i in response) {
          coupons.push(response[i]);
        }
        console.log('coupons', coupons);
        self.coupons = coupons;
        self.loading = false;
      });
    }
  },
  computed: {},
  watch: {
    user: function () {
      this.userdata = this.user;
      this.getRetrievedCoupons();
    }
  }
}
</script>


